<template>
  <div class="work-temp">
    <van-button
      class="work-temp-item"
      round
      plain
      type="info"
      v-for="item in workTempList"
      :key="item.key"
      @click="goTemp(item)"
      >{{ item.name }}
    </van-button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { clickButton } from '@plugins/biPoint/_configOfficialSupport';
import { buildWorkTempQuery } from '@utiles/officialSupport';
export default {
  name: 'WorkTempList',
  props: {
    source: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      workTempList: state => state.workTempList
    })
  },
  methods: {
    goTemp(item) {
      const { id, fixedProcessType } = item;
      clickButton({
        btnName: 'clickGoSmartOrder',
        locationKey: this.source || '',
        otherParams: {
          workTempId: id
        }
      });
      if (+fixedProcessType === 1) {
        this.$router.push({
          name: 'accountdelete',
          query: {
            workTempId: id,
            source: this.source || ''
          }
        });
        return;
      }
      this.$router.push({
        name: 'worktemp',
        query: buildWorkTempQuery({
          workTempId: id,
          source: this.source || ''
        })
      });
    }
  }
};
</script>

<style scoped lang="scss">
.work-temp {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto 26px;
  .work-temp-item {
    font-size: 14px;
    color: var(--main-color) !important;
    border: 1px solid var(--main-color);
    margin-right: 10px;
    margin-bottom: 15px;
    min-width: 80px;
    cursor: pointer;
  }
}
</style>
